export const MAX_RESULTS = 1000;
export const NEW_SEARCH_INDEX_MARKETS = ['se', 'no', 'gb', 'fr', 'fi', 'dk'];
